"use client";

import React from "react";
import { Sun, ShieldCheck, MapPin, FileCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const trustPillars = [{
  icon: Sun,
  title: "Increase Solar Efficiency"
}, {
  icon: ShieldCheck,
  title: "Safe Roof Methods"
}, {
  icon: MapPin,
  title: "Local & Reliable"
}, {
  icon: FileCheck,
  title: "Fully Insured"
}];
export default function OurPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-promise" className="py-12 md:py-16 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("relative rounded-3xl bg-secondary border border-white/60 shadow-lg overflow-hidden transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {}
          <div className="absolute inset-0 shadow-[inset_0_0_50px_rgba(255,255,255,0.8)] pointer-events-none z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10">
            {trustPillars.map((pillar, i) => <div key={i} data-index={i} className="relative flex flex-col items-center justify-center p-8 md:p-10 text-center group">
                <div className="relative mb-5">
                  {}
                  <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <pillar.icon className="w-10 h-10 text-primary relative z-10 stroke-[1.5] transition-transform duration-500 group-hover:scale-110 group-hover:-translate-y-1" />
                </div>
                
                <h3 className="text-secondary-foreground uppercase font-bold tracking-widest text-xs sm:text-sm leading-relaxed max-w-[180px]">
                  {pillar.title}
                </h3>

                {}
                
                {}
                <div className={cn("absolute right-0 top-1/4 bottom-1/4 w-px bg-gradient-to-b from-transparent via-secondary-foreground/15 to-transparent hidden lg:block", i === 3 ? "lg:hidden" : "")} />

                {}
                <div className={cn("absolute right-0 top-1/4 bottom-1/4 w-px bg-gradient-to-b from-transparent via-secondary-foreground/15 to-transparent hidden md:block lg:hidden", i === 1 || i === 3 ? "md:hidden" : "")} />

                {}
                <div className={cn("absolute bottom-0 left-1/4 right-1/4 h-px bg-gradient-to-r from-transparent via-secondary-foreground/15 to-transparent hidden md:block lg:hidden", i === 2 || i === 3 ? "md:hidden" : "")} />

                {}
                <div className={cn("absolute bottom-0 left-1/4 right-1/4 h-px bg-gradient-to-r from-transparent via-secondary-foreground/15 to-transparent block md:hidden", i === 3 ? "hidden" : "")} />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}